module.exports = __webpack_public_path__ + "img/more_arrow.e8d7245.png";